<div class="modal-container">
  <div class="panel-title-cont">
    <div class="panel-title">
      Drive Cycles
    </div>
    <div>
      <awc-button
        [text]="'Add Drive Cycle'"
        [prefixIcon]=" { icon: icons.ADD }"
        (buttonClicked)="addDriveCycle($event)"
      ></awc-button>
      <input cyData="drive-cycle-file-upload-input" #fileUpload type="file" (click)="uploadClick()" (change)="importDriveCycle($event)" style="display:none" accept=".csv">
    </div>
  </div>

  @if (driveCyclesLoaded) {
    <div class="relative-cont">
      <awf-table [tableId]="contributionsEnum.DRIVE_CYCLE_TABLE_ID" [filters]="filters" (rowClick)="selectionIDSet($event)"></awf-table>
    </div>
  } @else {
    <div class="loading-cont">
      <awc-icon [icon]="icons.SPINNER"></awc-icon>
    </div>
  }
</div>
